import React from "react";

//@Packages
import { useTranslation } from "react-i18next";
import {
  Modal,
  Table,
  TableContent,
  TableHeader,
  TableHeaderData,
} from "@forge/common";

//@Utils
import { LOCALE_CONST } from "../../../utils/constants";

//@Styles
import "./ConnectModal.scss";
import { convertUTCStringtoFormattedDate } from "../../../utils/utility";

interface ConnectUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  data: Array<any>;
  deviceName: string;
}

const ConnectedUsersModal: React.FC<ConnectUserModalProps> = ({
  isOpen,
  onClose,
  title,
  data,
  deviceName
}) => {
  const { t } = useTranslation();
  const tableHeaderData: TableHeaderData[] = [
    {
      id: "user",
      content: "User",
      canSort: true,
      canResize: false,
    },
    {
      id: "time",
      content: "Connected at",
      canSort: true,
    },
  ];

  const formatTableContent = (content: any) => {
    return content.map((item: any) => {
      return {
        id: item.user_id,
        cell: tableHeaderData.map((header) => {
          let cellContent = <span>{item[header.id]}</span>;
          if (header.id === "user") {
            cellContent = (
              <div className="flex items-center gap-2">                
                <span>{item.user_name}</span>
              </div>
            );
          }
          else if (header.id === "time") {
            cellContent = (
              <span>
                {convertUTCStringtoFormattedDate(item.connected_at)}
              </span>
            );
          }
          return { content: cellContent };
        })
      };
    });
  }

  return (
    <>
      {isOpen && (
        <Modal
          backdrop
          label={deviceName}
          title={title}
          onBackdropClick={onClose}
          onModalClose={onClose}
          className="connected_user_modal w-[480px]"
        >
          <Table>
            <TableHeader data={tableHeaderData} />
            <TableContent data={formatTableContent(data)} />
          </Table>
        </Modal>
      )}
    </>
  );
};

export default ConnectedUsersModal;
